import React from 'react';
import Certificate from './Certificate';

const CertificateDemo = () => {
  // Sample certificate data for demo
  const sampleCertificateData = {
    certificate_id: 'JS3K7M',
    student_name: 'John Smith',
    course_type: 'pro',
    completion_date: '2024-09-23T10:30:00.000Z',
    course_start_date: '2024-08-29',
    cpd_provider: '778495'
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 py-8">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-slate-800 mb-2">Certificate Preview</h1>
          <p className="text-slate-600">This is how your professional certificates will look</p>
        </div>
        
        <Certificate 
          certificateData={sampleCertificateData}
          onDownload={() => console.log('Certificate download demo')}
        />
        
        <div className="mt-8 text-center">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-2xl mx-auto">
            <h3 className="text-lg font-semibold text-slate-800 mb-4">Certificate Features</h3>
            <div className="grid md:grid-cols-2 gap-4 text-left">
              <div>
                <h4 className="font-semibold text-blue-600">Design Elements</h4>
                <ul className="text-sm text-slate-600 space-y-1">
                  <li>• Your Book Review Specialist logo</li>
                  <li>• Professional gradient background</li>
                  <li>• Clean, modern typography</li>
                  <li>• A4 landscape format</li>
                </ul>
              </div>
              <div>
                <h4 className="font-semibold text-blue-600">Certification Details</h4>
                <ul className="text-sm text-slate-600 space-y-1">
                  <li>• Unique Certificate ID (referral code)</li>
                  <li>• CPD Provider #778495</li>
                  <li>• Course completion date</li>
                  <li>• Diane Shawe signature section</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CertificateDemo;